import { render, staticRenderFns } from "./SiteRoomShelf.vue?vue&type=template&id=7c81db5a&"
import script from "./SiteRoomShelf.vue?vue&type=script&lang=js&"
export * from "./SiteRoomShelf.vue?vue&type=script&lang=js&"
import style0 from "./SiteRoomShelf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports